import { useEffect, useContext } from "react";
import { LoadingContext } from "react-router-loading";
import { TokenVerificationLoggedin, ScreenView } from "../utils/tokenVerify";
import MyProfileV2 from "./PublisherProfile/MyProfileV2";

const MyProfile = () => {
    const loadingContext = useContext(LoadingContext);

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView();

    }, [])

    return (
        <>
            <MyProfileV2 callFrom="profile" />
        </>
    )

};

export default MyProfile;
